import React, { useRef } from 'react';
import { useDrag } from './use-drag';

const DraggableComponent = ({ name, position_y, position_x }) => {
    const draggableRef = useRef(null);

    const { position, handleMouseDown } = useDrag({
        ref: draggableRef,
        calculateFor: 'default', // topLeft or bottomRight or default
        position_y: position_y,
        position_x: position_x
    });

    const divStyle = {
        position: 'absolute',
        top: `${position.y}px`,
        left: `${position.x}px`
    };

    if (name === 'card') {
        return <div className='card' ref={draggableRef} style={divStyle}>
            <div className='long-card-header' onMouseDown={handleMouseDown}>
                <p>прибыль</p>
            </div>
            <div className='card-body'>
                <div className='income-item'>
                    <p className='card-value'>$70 000</p>
                    <p className='card-percentage'>+10%</p>
                </div>
            </div>
        </div>;
    } else if (name === 'long-card') {
        return <div className='long-card' ref={draggableRef} style={divStyle}>
            <div className='long-card-header' onMouseDown={handleMouseDown}>
                <p>СРЕДНИЙ ДОХОД</p>
            </div>
            <div className='long-card-body'>
                <div className='income-item'>
                    <p className='income-title'>доход</p>
                    <p className='income-value'>$70 000</p>
                    <p className='income-change income-increase'>+10%</p>
                </div>
                <div className='divider'></div>
                <div className='income-item'>
                    <p className='income-title'>оператор</p>
                    <p className='income-value'>$15 000</p>
                    <p className='income-change income-decrease'>-3%</p>
                </div>
                <div className='divider'></div>
                <div className='income-item'>
                    <p className='income-title'>клиент</p>
                    <p className='income-value'>$15 000</p>
                    <p className='income-change income-decrease'>-3%</p>
                </div>
            </div>
        </div>;
    } else if (name === 'card-high') {
        return <div className='card-high' ref={draggableRef} style={divStyle}>
            <div className='long-card-header' onMouseDown={handleMouseDown}>
                <p>МЕНЕДЖЕРЫ</p>
            </div>
            <div className='high-card-body'>
                <div className='income-item'>
                    <p className='card-value'>45</p>
                    <p className='card-percentage'>+10%</p>
                </div>
            </div>
            <hr />
            <div className='high-card-body'>
                <div className='income-item'>
                    <p className='income-title'>доход</p>
                    <p className='income-value'>$70 000</p>
                    <p className='income-change income-increase'>+10%</p>
                </div>
            </div>
            <div className='divider'></div>
            <hr />
            <div className='high-card-body'>
                <div className='income-item'>
                    <p className='income-title'>Подченённых</p>
                    <p className='income-value'>15</p>
                </div>
            </div>
        </div>;
    }
};

export default DraggableComponent;